module.exports = __webpack_public_path__ + "images/icons_v2/calendar-outlined-b656dafb.svg";